export default {
  groupName: 'adpi-category-tentpole-events',
  appName: 'Quickview Live Events Dashboard',
  baseRoute: '/dashboard/adpi-quickview-live-events',
  label: 'AdPi Quickview Live Events Dashboard',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'AdPi Quickview Live Events Dashboard'
}
